import React from 'react'
import Payout from '../../myapp/services/payout'

function PayoutPage() {
  return (
    <Payout/>
  )
}

export default PayoutPage
